import { useSelector } from 'react-redux';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { routes } from './Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import QuotationClient from './Pages/Quotation/QuotationClient';
// import { API_URL } from './Config';


function App() {
  const state = useSelector((state) => state);
  const isAuthorized = state?.authState?.isAuthorized;
  const location = useLocation();

  // If user is logged in and tries to access '/', redirect to dashboard
  if (isAuthorized && location.pathname === '/') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className='App'>
      <ToastContainer />
      <Routes>
        {/* Standalone client route (no layout, no auth) */}
        <Route path="/quotation-client/:id" element={<QuotationClient />} />

        {/* Register public (unauthorized) routes only when NOT authorized */}
        {!isAuthorized && routes.filter((rt) => !rt.isAuthorized).map((noAuthRoute, routeIndex) => (
          <Route 
            key={routeIndex} 
            path={noAuthRoute.path} 
            element={<noAuthRoute.layout childRoutes={noAuthRoute.routes}  />} 
          />
        ))}

        {/* Register protected routes only when authorized */}
        {isAuthorized && routes.filter((rt) => rt.isAuthorized).map((authRoute, routeIndex) => (
          <Route 
            key={routeIndex} 
            path={authRoute.path} 
            element={<authRoute.layout childRoutes={authRoute.routes}  />} 
          />
        ))}
      </Routes>
    </div>
  )
}

export default App